import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=4736a527&scoped=true&"
import script from "./attachment.vue?vue&type=script&lang=js&"
export * from "./attachment.vue?vue&type=script&lang=js&"
import style0 from "./attachment.vue?vue&type=style&index=0&id=4736a527&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4736a527",
  null
  
)

export default component.exports